import React from "react";

const Crown = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M14.299 34c.011-.14.034-.282.034-.423l.001-19.208v-.448h-2.157v.455c0 2.94.002 5.879-.003 8.819 0 .236-.008.481-.072.706-.166.589-.778.99-1.372.933-.656-.063-1.167-.551-1.239-1.191-.014-.13-.01-.262-.01-.392-.001-3.047-.002-6.094 0-9.141 0-2.351 1.625-3.966 3.992-3.967 3.091-.002 6.183-.002 9.275 0 2.366 0 3.991 1.615 3.992 3.967v9.248c-.002.8-.427 1.335-1.144 1.458-.707.122-1.418-.382-1.521-1.087a4.061 4.061 0 0 1-.031-.57c-.003-2.915-.002-5.832-.002-8.748v-.487h-2.136c-.006.122-.02.247-.02.373 0 7.594 0 11.759.002 19.352 0 .117.022.234.033.351H19.19V23.488H17.03V34h-2.732ZM18.614 2c.66.203 1.321.401 1.847.887.984.91 1.433 2.02 1.168 3.339-.267 1.334-1.075 2.24-2.377 2.715-2.243.817-4.842-.946-4.732-3.565.067-1.58 1.239-2.915 2.892-3.305.067-.016.13-.047.194-.071h1.008Z"
            fill={fill}
        />
        <path className="u_fill"
            d="M24.064 33.1v-6.27c.604.04 1.2.163 1.776.1 1.742-.194 3.042-1.668 3.055-3.412.015-2.118.003-4.236.004-6.355v-.277l.059-.015c.12.315.241.63.358.945 1.028 2.788 2.05 5.58 3.084 8.366.574 1.547.848 3.14.82 4.788-.003.216-.077.31-.274.38-2.625.947-5.32 1.564-8.113 1.732-.227.014-.453.032-.68.047-.024 0-.047-.015-.09-.028ZM12.162 26.808v6.333c-.667-.051-1.32-.078-1.967-.154a30.173 30.173 0 0 1-6.863-1.617c-.262-.096-.328-.22-.331-.484a13.166 13.166 0 0 1 .852-4.783c1.119-2.996 2.214-6 3.32-9a.446.446 0 0 1 .15-.222v.364c0 2.058-.006 4.118 0 6.176.006 1.878 1.333 3.362 3.211 3.532.521.047 1.06-.089 1.628-.145Z"
            fill={fill}
        />
    </svg>
);

export default Crown;
